module.exports = __webpack_public_path__ + "static/media/product-5.08961f34.jpg";